import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCountryOptions } from '@mews-commander/legacy-entities/src/ducks/countries';
import { LocalizedText } from '@mews/framework';
import { OptionalKeys } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { SelectField, SelectFieldProps } from '../reduxFields';

type NationalitySelectFieldProps = OptionalKeys<SelectFieldProps, 'name'>;

const defaultNationalitySelectFieldProps = {
    name: 'nationality',
    label: <LocalizedText textKey={TextKey.Nationality} />,
    filterable: true,
    showEmptyValue: true,
};

const NationalitySelectField = (props: NationalitySelectFieldProps) => (
    <SelectField {...defaultNationalitySelectFieldProps} {...props} />
);

export default connect(
    createStructuredSelector({
        options: getCountryOptions,
    })
)(NationalitySelectField);
